export const ALL_APPS = [
  "approve",
  "dashboard",
  "jetforce",
  "tag-generator",
  "ROI-ALPHAJET",
  "ROI-JETVARNISH3DEVO",
  "ROI-WEB400",
  "predict",
  "estimate",
  "appshop",
  "foilshop",
  "alphajet-viewer",
  "guidelines",
  "docapprove",
  "docdashboard",
  "register",
  "equipment-factory",
];

export function getAvailableApps(userApps: string[]): APPS_TYPE[] {
  if (!userApps.includes("register")) {
    userApps = [...userApps, "register"];
  }

  if (!userApps.includes("roi-jetvarnish") && userApps.includes("roi")) {
    userApps.splice(userApps.indexOf("roi") + 1, 0, "roi-jetvarnish");
  }

  userApps = userApps
    .sort((u) => {
      // TODO : sort with a range of app
      if (u === "register") return -1;
      else return 0;
    })
    .sort((v) => {
      if (v === "predict") return -1;
      else return 0;
    });

  return userApps.filter(
    (app) => ALL_APPS.includes(app) && !USER_APPS_EXTERNAL.includes(app),
  );
}
export function getUserApps(userApps: string[]): APPS_TYPE[] {
  const sortByObject: any = USER_APPS_EXTERNAL.reduce((obj, item, index) => {
    return {
      ...obj,
      [item]: index,
    };
  }, {});

  return userApps
    .filter((app) => USER_APPS_EXTERNAL.includes(app))
    .sort((a, b) => sortByObject[a] - sortByObject[b]);
}
export function getResourceApps(availableApps: string[]): APPS_TYPE[] {
  const docs = [];

  if (availableApps.includes("dashboard")) {
    docs.push("docdashboard");
  }
  if (availableApps.includes("predict")) {
    docs.push("docpredict");
  }
  if (availableApps.includes("approve")) {
    docs.push("docapprove", "guidelines");
  }

  return docs;
}

export type APPS_TYPE = (typeof ALL_APPS)[number];

export const USER_APPS_EXTERNAL: APPS_TYPE[] = [
  "approve",
  "dashboard",
  "jetforce",
  "estimate",
];

export interface AppsInfos {
  name: string;
  logo: string;
  color: string;
  link: string;
}

export {};
